<shell-layout *ngIf="config" class="pt-12">
  <img class="error__img" [src]="config.imageUrl.url" [alt]="config.imageUrl.altUrl" />

  <ui-text class="error__title" color="blue-500" size="h4" weight="semibold">
    {{ config.errorTitle }}
  </ui-text>

  <ui-text class="error__description" color="blue-300">
    {{ config.errorDescription }}
  </ui-text>

  <ui-button
    (clicked)="closeModal()"
    class="error__action"
    type="primary"
    [label]="config.buttonLabel"
  ></ui-button>
</shell-layout>
